import mapbox from 'mapbox-gl';

export const accessToken = import.meta.env.VITE_REACT_APP_MAP_BOX_PUBLIC_TOKEN;

mapbox.accessToken = accessToken;

export default mapbox;
